"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkSpanAttributesProcessor = void 0;
class SplunkSpanAttributesProcessor {
    constructor(globalAttributes) {
        this._globalAttributes = globalAttributes !== null && globalAttributes !== void 0 ? globalAttributes : {};
    }
    setGlobalAttributes(attributes) {
        if (attributes) {
            Object.assign(this._globalAttributes, attributes);
        }
        else {
            for (const key of Object.keys(this._globalAttributes)) {
                delete this._globalAttributes[key];
            }
        }
    }
    _experimental_getGlobalAttributes() {
        return this._globalAttributes;
    }
    forceFlush() {
        return Promise.resolve();
    }
    onStart(span) {
        span.setAttribute('location.href', location.href);
        span.setAttributes(this._globalAttributes);
    }
    onEnd() {
        // Intentionally empty
    }
    shutdown() {
        return Promise.resolve();
    }
}
exports.SplunkSpanAttributesProcessor = SplunkSpanAttributesProcessor;
//# sourceMappingURL=SplunkSpanAttributesProcessor.js.map